import { actions } from './payment/actions'
import { getters } from './payment/getters'
import { state } from './payment/state'
import { mutations } from './payment/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}